export const GET_TRANSLATIONS = "GET_TRANSLATIONS";
export const UPDATE_TRANSLATIONS = "UPDATE_TRANSLATIONS";
